import {ICON_TYPES} from '../constants';

export const InstagramIcon = (): JSX.Element => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.9978 8.76465C10.2131 8.76465 8.75999 10.2177 8.75999 12.0025C8.75999 13.7872 10.2131 15.2403 11.9978 15.2403C13.7825 15.2403 15.2356 13.7872 15.2356 12.0025C15.2356 10.2177 13.7825 8.76465 11.9978 8.76465Z'
        fill='white'
      />
      <path
        d='M16.3745 3H7.62545C5.07709 3 3 5.07273 3 7.62545V16.3745C3 18.9229 5.07273 21 7.62545 21H16.3745C18.9229 21 21 18.9273 21 16.3745V7.62545C20.9956 5.07709 18.9229 3 16.3745 3ZM11.9978 16.5578C9.48436 16.5578 7.43782 14.5113 7.43782 11.9978C7.43782 9.48436 9.48436 7.43782 11.9978 7.43782C14.5113 7.43782 16.5578 9.48436 16.5578 11.9978C16.5578 14.5156 14.5113 16.5578 11.9978 16.5578ZM17.1076 8.25382C16.5447 8.25382 16.0909 7.79564 16.0909 7.23709C16.0909 6.67418 16.5491 6.22036 17.1076 6.22036C17.6705 6.22036 18.1244 6.67855 18.1244 7.23709C18.1244 7.79564 17.6705 8.25382 17.1076 8.25382Z'
        fill='white'
      />
    </svg>
  );
};

InstagramIcon.iconType = ICON_TYPES.INSTAGRAM;
